/* SearchDropdownEmbedded.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["inputFocused"],
  _excluded3 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _19 = "._16qs1402{box-shadow:0 0 1px 0 rgba(9,30,66,.31),0 3px 5px 0 rgba(9,30,66,.2)}";
const _18 = "._154i1ady{top:44px}";
const _17 = "._kqswstnw{position:absolute}";
const _16 = "._bfhk3etr{background-color:var(--ds-text-inverse)}";
const _15 = "._2rkoftgi{border-radius:8px}";
const _14 = "._1bsb1k7l{width:757px}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives/responsive';
import { breakpointValues, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import { useHistory, useLocationHref, useQueryParams } from '@atlassian/mpac-ui';
import React, { useRef } from 'react';
import { useAlgoliaAutocomplete } from '../../AlgoliaClientSDK/useAlgoliaAutocomplete';
import { desktopPlaceholder, mobilePlaceholder } from '../../constants';
import { RecentSearch } from '../../SearchUtils';
import { redirectToNewQuery } from '../../SearchUtils/search-navigation-utils/SearchNavigationUtils';
import { SearchBodyFactory } from '../SearchBodyFactory';
import { SearchHeader } from '../SearchHeader';
import { useAutocompleteState } from './hooks/useAutocompleteState';
import { useSearchDropdown } from './hooks/useSearchDropdown';
const _13 = "._1h6d4emh{border-color:var(--ds-border-input)}";
const _12 = "._1h6d1oj9{border-color:var(--ds-border-selected)}";
const _11 = "@media (min-width:64rem){._1yag1dzv{padding:var(--ds-space-100) var(--ds-space-150)}}";
const _10 = "._4cvr1h6o{align-items:center}";
const _9 = "._11q71xnl{background:var(--ds-background-input)}";
const _8 = "._19it1axk{border:2px solid}";
const _7 = "._2rkoi2wt{border-radius:6px}";
const _6 = "._syaz1jij{color:var(--ds-text-subtlest)}";
const _5 = "._zulp1eps{gap:var(--ds-space-100)}";
const _4 = "._1e0c1txw{display:flex}";
const _3 = "._1yt41eps{padding:var(--ds-space-100)}";
const _2 = "._4t3i1ylp{height:40px}";
const _ = "._1bsb1hdq{width:var(--_6f8077)}";
const Header = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  const {
      inputFocused
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13]), /*#__PURE__*/React.createElement(C, _extends({}, __cmpldp, {
    style: _objectSpread(_objectSpread({}, __cmpls), {}, {
      "--_6f8077": ix("".concat(__cmplp.width, "px"))
    }),
    ref: __cmplr,
    className: ax(["_1bsb1hdq _4t3i1ylp _1yt41eps _1e0c1txw _zulp1eps _syaz1jij _2rkoi2wt _19it1axk _11q71xnl _4cvr1h6o _1yag1dzv", __cmplp.inputFocused ? "_1h6d1oj9" : "_1h6d4emh", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Header.displayName = 'Header';
}
const SearchBodyWrapper = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_14, _15, _16, _17, _18, _19]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bsb1k7l _2rkoftgi _bfhk3etr _kqswstnw _154i1ady _16qs1402", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SearchBodyWrapper.displayName = 'SearchBodyWrapper';
}
// RECENT SEARCH HANDLINGS
const recentSearch = new RecentSearch(5, 'mpac-search-recent-searches');
export function SearchDropdownEmbedded(_ref3) {
  let {
    inputWidth
  } = _ref3;
  const [inputFocused, setInputFocused] = React.useState(false);

  // LOCATION HANDLINGS
  const {
    query: queryFromUrl
  } = useQueryParams();
  const locationHref = useLocationHref();
  const history = useHistory();

  // AUTOCOMPLETE HANDLINGS
  const inputRef = useRef(null);
  const handleNewSearch = hit => {
    recentSearch.push(hit);
    redirectToNewQuery({
      query: hit.query,
      locationHref,
      history
    });
  };
  const {
    value: breakpoint
  } = useResponsiveBreakpoint();
  const isMobile = breakpoint < breakpointValues.md;
  const {
    autocomplete,
    autocompleteState
  } = useAlgoliaAutocomplete(inputRef, isMobile ? mobilePlaceholder : desktopPlaceholder, queryFromUrl, handleNewSearch, recentSearch);
  const {
    handleAppend,
    handleEnterKeyPress,
    clearRecentSearches,
    clearSearchInput
  } = useSearchDropdown({
    inputRef,
    autocomplete
  });

  // BODY STATE HANDLINGS
  const {
    bodyState
  } = useAutocompleteState({
    autocompleteState
  });
  const searchSuggestionProps = {
    hits: autocompleteState.collections,
    autocomplete,
    onAppend: handleAppend
  };
  const onFocus = () => {
    setInputFocused(true);
  };
  const onBlur = () => {
    setInputFocused(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, _extends({}, autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.getRootProps({}), {
    width: inputWidth,
    inputFocused: inputFocused
  }), /*#__PURE__*/React.createElement(SearchHeader, {
    autocomplete: autocomplete,
    ref: inputRef,
    handleEnterKeyPress: handleEnterKeyPress,
    clearSearchInput: clearSearchInput,
    onFocus: onFocus,
    onBlur: onBlur
  })), inputFocused && /*#__PURE__*/React.createElement(SearchBodyWrapper, null, /*#__PURE__*/React.createElement(SearchBodyFactory, {
    type: bodyState,
    searchQuerySuggestionsBodyProps: _objectSpread({
      query: autocompleteState.query
    }, searchSuggestionProps),
    searchLoadingProps: {
      count: 6,
      query: autocompleteState.query
    },
    recentSearchBodyProps: _objectSpread({
      onClearAll: clearRecentSearches
    }, searchSuggestionProps),
    noSuggestionsBodyProps: {
      query: autocompleteState.query
    }
  })));
}